import React from "react";
// styles
import injectSheet from 'react-jss';
import styles from './status_styles';


const Status = injectSheet(styles)((props) => {
  return (
    <div className={`${props.classes.status} ${props.status.toLowerCase()} ${props.klass}`}>
      <span className="circle"></span>
      {props.status.toLowerCase()}
    </div>
  )
});

export default Status;